import { Injectable } from '@angular/core';
import { RepositoryService, UnitOfWorkService } from '@mri/breeze-entity';
import { MetadataStore } from 'breeze-client';
import { DatasetAccess } from '../models';
import { datasetAccessQueries } from './queries';

@Injectable({ providedIn: 'root' })
export class DatasetAccessRepositoryService extends RepositoryService<DatasetAccess> {
  constructor(uow: UnitOfWorkService, metadataStore: MetadataStore) {
    super(uow, metadataStore, datasetAccessQueries.selectAll);
  }
}
